import React, { FC, useCallback } from 'react';
import { ICalendarUrl, setClass } from '../../utils';
import { Input } from '../input';
import { Trash } from '../svgs';
import '../../styles/components/calendarUrl.scss';

interface CalendarUrlProps {
  calendar: ICalendarUrl;
  onDeleteCalendar?: () => void;
  onChange?: (calendar: ICalendarUrl) => void;
  newCalendar?: boolean;
  error: boolean;
  setErr?: (value: boolean) =>  void;
}

export const CalendarUrl: FC<CalendarUrlProps> = ({ 
  calendar, onDeleteCalendar, newCalendar, error, onChange, setErr 
}) => {
  const onChangeUrl = useCallback((calendarUri: string) => {
    onChange({ ...calendar, calendarUri });
    error && setErr(false);
  }, [calendar, error]);
  return (
    <div className={setClass("url-part", newCalendar && "without-margin")}>
      <Input
        variant="square"
        placeholder='Вставьте ссылку'
        disabled={!newCalendar}
        onChange={onChangeUrl}
        value={calendar.calendarUri}
        error={error}
      />
      <Trash
        onClick={onDeleteCalendar}
        divClassName={setClass(newCalendar && 'hidden')}
      />
    </div>
  );
};